export const RECON_DATA = {
  header: {
    uploadText: "Upload New File",
    uploadTextDescription: "Start reconciling your zomato/ swiggy payout files.",
    discrepancyText: "Discrepancy Reconciliations",
    pendingTextDescription: "Easily access all files with payout discrepancies and missing orders in one place."
  },
  fileUpload: {
    sampleFilelink: "https://drive.google.com/drive/folders/1cDKUq_jwVnb-JxI-25LmQzJRosd_-N4Q",
    maxSize: "Max size: 10MB each (up to 5 files)",
    supportedFormat: "Supported formats: XLS, XLSX",
    chooseFileHeader: "Upload New Payout File",
    chooseFileDescription: "Start reconciling your Zomato/ Swiggy payout files.",
    header: "How it works ?",
    steps: [
      { header: "Upload your file", description: "Upload your XLS or XLSX file with payout data. You can upload up to 5 files at once", sampleFile: ["Need a sample ? ", "Download an example file", " to see the correct fields for Zomato and Swiggy payouts."] },
      { header: "Review Results", description: "Once the file is uploaded, we'll automatically match your orders with payouts and highlight any discrepancies or unmatched transactions for review." }
    ],
    notes: [
      'For easy tracking, name your file with relevant details like the date (e.g., Zomato_July20 24_Week1.xls).',
      'For accurate reconciliation, avoid modifying the payout file format or fields.'
    ],
    reconStarted: "Reconciliation Started",
  },
  reconLogsModal: {
    header: "Reconciliation Logs",
    noLogsHeader: "No logs available yet",
    noLogsDescription: "Your reconciliation history will appear here once you upload and process files.",
  },
  reconStatusModal: {
    reconSuccess: "Successfully Reconciled",
    doNotExit: "Please do not refresh or close the window",
    inProgress: "Reconciliation initiated. Preparing your data...",
    noErrors: "No Errors found",
    fixErrors: "You can fix the files with errors and re-upload them later.",
  },
  reports: {
    noFilterResults: "No results match your filter! 🔍",
    checkLogs: 'Check Logs',
    checkLogsTooptip: "You can access your reconciliation history here.",
    noFilterResultsDescription: "Our recon engine couldn’t find any files matching your selected criteria. Try adjusting the filters to see more results.",
    howIsCalculated: "How does Rista calculate payout?",
    reportHeader: "Reconciliation Reports",
    reportHeaderDiscrepancy: "Discrepancy Reconciliations",
    noFileHeader: "No payout files uploaded yet!",
    noFileDescription: "Upload your Swiggy or Zomato files to get a clear view of your order and payment records, all in one place."
  },
  download: {
    emailSentHeader: "Email Sent!",
    downloadDoneHeader: "Success!",
    downloadDoneInfo: "Your detailed discrepancy report is being prepared. You can visit the downloads section to check its status anytime.",
    emailDoneInfo: (id: string)=> `Your detailed discrepancy report has been sent to your email: ${id}. Please check your inbox.`,
  }
};

export const RECON_UPLOAD_LIST_TABLE_COLUMNS = {
  dateRange: "Date Range",
  aggregator: "Aggregator",
  branch: "BRANCH (RES.ID)",
  orders: "ORDERS",
  amount: "AMOUNT",
  reconStatus: "RECON STATUS",
  payoutVariance: "PAYOUT VARIANCE",
} as const;
export type ReconUploadColumnKeys = keyof typeof RECON_UPLOAD_LIST_TABLE_COLUMNS;

export const RECON_REPORT_LIST_TABLE_COLUMNS = {
  checkBox: "",
  dateRange: "Date Range",
  aggregator: "Aggregator",
  branch: "BRANCH (RES.ID)",
  orders: "ORDERS",
  amount: "AMOUNT",
  reconStatus: "RECON STATUS",
  payoutVariance: "PAYOUT VARIANCE",
  actions: "ACTIONS"
} as const;
export type ReconColumnKeys = keyof typeof RECON_REPORT_LIST_TABLE_COLUMNS;

export const RECON_PENDING_LIST_TABLE_COLUMNS = {
  createdDate: 'Created Date',
  aggregator: "Aggregator",
  branch: "BRANCH (RES.ID)",
  fileName: "File Name"
} as const;
export type ReconPendingColumnKeys = keyof typeof RECON_PENDING_LIST_TABLE_COLUMNS;


export const RECON_LOGS_TABLE_COLUMNS = {
  date: 'DATE',
  fileName: 'FILE NAME',
  uploadedBy: 'UPLOADED BY',
  reconStatus: 'RECON STATUS',
} as const;
export type ReconLogsColumnKeys = keyof typeof RECON_LOGS_TABLE_COLUMNS;
export const recon_logs_default_limit = 10;